// extracted by mini-css-extract-plugin
module.exports = {"chat":"GQHF","container":"_5Fnh"};